import { StoreImage, StoreImageEnum, getSocialLinkIcon } from '@systemeio/digital-store-shared'
import {
  STORE_ITEM_BUTTON_CLASS_NAME,
  STORE_ITEM_CLASS_NAME,
} from 'modules/stores/store/constants/store-item-class-name'
import { StoreTabEnum } from 'modules/stores/store/enum/store-tab-enum'
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query'
import { StoreInterface } from 'modules/stores/types/stores-interface'
import React, { FC } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { twMerge } from 'tailwind-merge'
import { PenIcon } from '@systemeio/ui'

interface ProfileContentProps {
  profile: StoreInterface['profile']
  socialMedia: StoreInterface['socialLinks']
}

const ProfileContent: FC<ProfileContentProps> = ({ profile, socialMedia }) => {
  const { t } = useLocoTranslation()

  const { onChangeTab } = useStoreQuery()

  return (
    <button
      onClick={() => onChangeTab(StoreTabEnum.profile)}
      className={twMerge(
        STORE_ITEM_CLASS_NAME,
        STORE_ITEM_BUTTON_CLASS_NAME,
        'flex flex-col items-center gap-5 sm:flex-row sm:items-start',
      )}
    >
      <StoreImage
        imageType={StoreImageEnum.profile}
        alt={profile.sellerName}
        thumbnail={profile.sellerPhoto}
        className="border-brand-primary shrink-0 rounded-full border-2 object-cover"
        skipTheme
      />
      <div className={'flex flex-col sm:items-start'}>
        <span className={'text-text-primary break-words text-2xl font-bold'}>
          {profile.sellerName}
        </span>
        <span className={'break-words text-lg'}>{profile.bio}</span>
        <div className={'mt-2 flex flex-wrap justify-center gap-1.5'}>
          {socialMedia.map(media => (
            <div key={media.type} className={'border-text-secondary/30 rounded-md border p-1'}>
              {getSocialLinkIcon(media.type, 'fill-brand-primary')}
            </div>
          ))}
        </div>
      </div>
      <div className={'sm:ml-auto'}>
        <div className={'flex gap-1'}>
          <PenIcon className={'fill-brand-primary h-4 w-4'} />
          <span className={'text-brand-primary whitespace-nowrap'}>
            {t('dashboard.store.profile.edit_profile')}
          </span>
        </div>
      </div>
    </button>
  )
}

export default ProfileContent
